module.exports = __webpack_public_path__ + "static/img/juan.83481b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/juan.png
// module id = 75m2
// module chunks = 1